import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Eye, EyeSlash, CircleNotch } from '@phosphor-icons/react';

export default function ClientLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { clientLogin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await clientLogin(email, password);
      navigate('/portal');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Credenciales invalidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900" data-testid="client-login-page">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <img
              src="https://customer-assets.emergentagent.com/job_0246dde3-e1c1-4ddd-b1f0-cbdadc084ea8/artifacts/indb97if_WhatsApp%20Image%202026-02-08%20at%208.04.43%20PM%20%281%29.jpeg"
              alt="IQES Logo"
              className="w-20 h-20 object-contain mx-auto mb-4 rounded-xl shadow-2xl ring-2 ring-white/20"
            />
            <h1 className="text-3xl font-black text-white mb-1">IQES LLC</h1>
            <p className="text-blue-300 text-sm">Low Voltage Solutions</p>
          </div>

          <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-8 border border-white/10 shadow-2xl">
            <div className="text-center mb-6">
              <h2 className="text-xl font-bold text-white mb-1">Portal de Cliente</h2>
              <p className="text-slate-300 text-sm">Accede a tus cotizaciones, facturas y ordenes</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-slate-200 mb-1.5">Correo electronico</label>
                <input
                  type="email" value={email} onChange={e => setEmail(e.target.value)}
                  className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-xl text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                  placeholder="tu@email.com" required data-testid="client-login-email"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-200 mb-1.5">Contrasena</label>
                <div className="relative">
                  <input
                    type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)}
                    className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-xl text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent pr-10"
                    placeholder="••••••••" required data-testid="client-login-password"
                  />
                  <button type="button" onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white">
                    {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>
              {error && (
                <div className="bg-red-500/20 border border-red-400/30 text-red-200 px-4 py-3 rounded-xl text-sm" data-testid="client-login-error">
                  {error}
                </div>
              )}
              <button type="submit" disabled={loading}
                className="w-full py-3 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-xl transition-all flex items-center justify-center gap-2 disabled:opacity-50"
                data-testid="client-login-submit">
                {loading ? <><CircleNotch size={20} className="animate-spin" /> Ingresando...</> : 'Ingresar al Portal'}
              </button>
            </form>
          </div>

          <p className="text-center mt-6 text-sm text-slate-400">
            IQES LLC &copy; 2026 - Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
}
